import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../lib/api';

const SeasonContext = createContext();

export function SeasonProvider({ children }) {
    const [currentSeason, setCurrentSeason] = useState('');
    const [availableSeasons, setAvailableSeasons] = useState([]);
    const [defaultSeason, setDefaultSeason] = useState('');

    useEffect(() => {
        API.get('/available-seasons').then(res => {
            const { seasons, current } = res.data;
            setAvailableSeasons(seasons);
            setDefaultSeason(current);
            setCurrentSeason(current);
        }).catch(() => {});
    }, []);

    return (
        <SeasonContext.Provider value={{ currentSeason, setCurrentSeason, availableSeasons, defaultSeason }}>
            {children}
        </SeasonContext.Provider>
    );
}

export function useSeason() {
    return useContext(SeasonContext);
}
